import {
  GraphQLField, GraphQLList, GraphQLUnionType,
} from 'graphql';
import { FieldComponent, FieldComponentParams } from '@/types/FieldComponent';
import FieldCollection from '@/components/FormBuilder/fields/FieldCollection.vue';
import { FieldNormalizer } from '@/classes/normalizers/types';
import FieldCollectionNormalizer from '@/classes/normalizers/field-normalizers/FieldCollectionNormalizer';
import PreviewCollectionField from '@/components/FormBuilder/preview/PreviewCollectionField.vue';
import FieldComponentFactory from './FieldComponentFactory';
import AbstractFieldComponentFactory from './AbstractFieldComponentFactory';

export default class FieldCollectionFactory extends FieldComponentFactory {
  readonly component = FieldCollection;

  readonly previewComponent = PreviewCollectionField;

  constructor(
    private factory: AbstractFieldComponentFactory,
    private normalizer: FieldNormalizer = new FieldCollectionNormalizer(),
  ) {
    super();
  }

  beforeSaveNormalizer(fieldName: string, value: any) {
    return this.normalizer.normalize({ fieldName, value });
  }

  support(field: GraphQLField<any, any, any>) {
    const { type } = field;
    return this.typeInspector.isFieldCollection(type) || this.typeInspector.isMutationFieldCollection(type);
  }

  // TODO: Прибраться: функция выполняет сразу несколько задач и уровень абстракций -- смешанный
  async createComponent(params: FieldComponentParams) {
    const componentParams = { ...params };
    const { field } = componentParams;

    let fields: GraphQLField<any, any, any>[] = [];
    let fieldCollectionName = '';

    if (this.typeInspector.isListType(field.type)) {
      const fieldType = field.type as GraphQLList<GraphQLUnionType>;
      const unionedType = fieldType.ofType.getTypes()[0];
      [, fieldCollectionName] = unionedType.name.split('_');
      fields = Object.values(unionedType.getFields());
    }

    if (this.typeInspector.isInputObjectType(field.type)) {
      const { items }: any = field.type.getFields();
      const itemsFields: any = items.type.getFields();
      [fieldCollectionName] = Object.keys(itemsFields);
      const rawFields: GraphQLField<any, any, any>[] = Object.values(itemsFields[fieldCollectionName].type.ofType.getFields());
      fields = this.filterIndexField(rawFields);
    }

    const fieldComponents = await this.factory.createComponentsFromFields(fields);

    componentParams.attrs = {
      collection: params.name,
      fieldComponents,
    };

    const fieldComponent: FieldComponent = {
      component: this.component,
      previewComponent: this.previewComponent,
      beforeSave: this.beforeSaveNormalizer.bind(this, fieldCollectionName),
      validationRules: [],
      props: componentParams.props || {},
      attrs: componentParams.attrs,
      ...componentParams,
    };

    return fieldComponent;
  }

  private filterIndexField(fields: GraphQLField<any, any, any>[]) {
    return fields.filter((f) => !f.name.includes('index'));
  }
}
